import { Util } from "@base/util/Util";
import { CommonLogic } from "@biz/CommonLogic";
import { LanguageType, Unit } from "@biz/Definitions";
import { IBeosArticle, IShoppingArticle } from "@biz/definitions/ArticleDefinitions";
import { Gender } from "@biz/definitions/DatabaseDefinitions";
import { ISunSailData, PoleId } from "@biz/definitions/SunSailDefinitions";
import { Poles } from "@biz/items/sunSail/logic/Poles";
import { LanguageId } from "@biz/language/Languages";
import { ILocaContext } from "@biz/language/LocaContext";
import { Measure } from "@biz/logic/Measure";

export class QuoteHelper {
  /** @deprecated */
  static _getSalutationText(sex: Gender, lc: ILocaContext): string {
    const { t } = lc;
    switch (sex) {
      case "F":
        return t("Quote_Letter_Female");
      case "M":
        return t("Quote_Letter_Male");
      case "C":
        return t("Quote_Letter_Company");
      case "D":
        return t("Quote_Letter_Divers");
    }
    return t("Quote_Letter_Company");
  }

  static getSalutation(user: ({ sex?: Gender } | { gender?: Gender }) & { firstName?: string, lastName?: string } | undefined, lc: ILocaContext): string {
    const { t } = lc;
    if (!user)
      return t("Quote_Letter_Undefined");
    const { firstName, lastName } = user;
    const name = [firstName, lastName].filter((f) => !!f).join(" ");
    const nameWithSpace = (name ? " " + name : "");
    switch ("sex" in user ? user.sex : ("gender" in user ? user.gender : "M")) {
      case "F":
        return t("Quote_Letter_Female") + nameWithSpace;
      case "M":
        return t("Quote_Letter_Male") + nameWithSpace;
      case "D":
        return t("Quote_Letter_Divers") + nameWithSpace;
      case "C":
        return t("Quote_Letter_Company");
    }
    return t("Quote_Letter_Company");
  }

  static getAngleString(angle: number): string {
    return angle.toFixed(1) + QuoteHelper.nonBreakingSpace + "°";
  }

  static getDistanceString(distance: number, unit: string): string {
    return distance.toFixed(2) + QuoteHelper.nonBreakingSpace + unit;
  }

  static getAreaString(distance: number): string {
    return distance.toFixed(2) + QuoteHelper.nonBreakingSpace + Measure.m2;
  }

  static nonBreakingSpace = '\xa0';

  static fixUnit(unit: string): string {
    if (unit === "m2")
      return Measure.m2;
    return unit;
  }

  static getUnitString(unit: Unit, lc: ILocaContext): string {
    const unitId = ("Unit_" + unit) as LanguageId;
    if (lc._lf[unitId] !== undefined)
      return lc.t(unitId);
    return unitId
  }

  static getAmount(amount: number, unit: Unit, lc: ILocaContext): string {
    const unitString = QuoteHelper.getUnitString(unit, lc);
    return Util.round(amount, 2) + QuoteHelper.nonBreakingSpace + QuoteHelper.fixUnit(unitString);
  }

  static getPoleText(ssd: ISunSailData, poleId: PoleId, lc: ILocaContext): string {
    return lc.t("Quote_Pole") + QuoteHelper.nonBreakingSpace + Poles.getPointText(ssd, poleId);
  }

  static getClientAvailableForOffer(article: IShoppingArticle, forEndUser: boolean): number {
    if (forEndUser) return 0;
    return article.countClientAvailable || 0;
  }

  static getArticleName(beosArticle: IBeosArticle, languageType: LanguageType): string {
    return beosArticle.localizedNames ? CommonLogic.getLocalizedName(beosArticle.localizedNames, languageType) : beosArticle.name;
  }

  static getArticleDescription(beosArticle: IBeosArticle, languageType: LanguageType): string {
    return beosArticle.localizedDescriptions ? CommonLogic.getLocalizedName(beosArticle.localizedDescriptions, languageType) : beosArticle.desc;
  }
}
